import React from 'react';
import { translate } from 'react-i18next';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import TextField from 'material-ui/TextField';

class Discount extends React.Component {

  render()  {
    const {t} = this.props;

    const symbol = (this.props.discountType === 'percent') ? ' %'
      : (this.props.discountType === 'euro' || this.props.discountType === 'certain') ? ' €' : '';

    return (
      <div className='col-xs col-md-7'>
        <span className='headerSpanStyle'>
          {t('offer.discountType')}
        </span>
        <RadioButtonGroup
          name={t('offer.discountType')}
          valueSelected={this.props.discountType}
          onChange={this.props.handleDiscountTypeChange}>
          <RadioButton
            value='percent'
            label={t('offer.percentDiscount')}
            className='switchButton'
          />
          <RadioButton
            value='euro'
            label={t('offer.euroDiscount')}
            className='switchButton'
          />
          <RadioButton
            value='certain'
            label={t('offer.certainDiscount')}
            className='switchButton'
          />
        </RadioButtonGroup>
        <TextField
          floatingLabelText={t('offer.discountAmount') + symbol}
          className='textFieldNextToRadio'
          value={this.props.discount}
          errorText={this.props.discountError}
          onChange={this.props.handleDiscountChange}
          disabled={!this.props.discountType}
          onBlur={this.props.applyDiscountChange}
        />
        <div className='paddingDiv'/>
      </div>
    );
  }

}

export default translate()(Discount);



// WEBPACK FOOTER //
// ./src/Offer/Discount.js